module.exports = __webpack_public_path__ + "img/w3_chevron_up_dark.ec238f5f.ec238f5f.png";